module.exports = __webpack_public_path__ + "static/media/consultationPppSk.0328e39f.jpg";